import { StudioShell } from './studio-shell';

export const DigitizationPage = () => (
  <StudioShell>
    <p className="type-body text-cream/45">
      Оберіть драфт на панелі праворуч або почніть новий запис.
    </p>
  </StudioShell>
);
